module.exports = __webpack_public_path__ + "static/media/diktat-intro.21174848.mp3";